import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Check, Times } from '../../../components/Icon';
import { Modal } from '../../../components/Modal';
import { setVehicleProperty } from '../actions';

const Container = styled.div``;

const STATE = {
  edit: false,
};
/* eslint-disable react/prefer-stateless-function */
class SetActionStateButton0123Comp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  componentDidMount() {}

  render() {
    return (
      <Container>
        <HBox vCenter left>
          <Button small onClick={this.setStateFn({ edit: true })}>
            {this.lbl(`task.progress.${this.props.vehicle[this.props.propertyName] || '0'}`)}
          </Button>
          &nbsp;&nbsp;
          {this.lbl(`vehicle.property.${this.props.propertyName}`)}
        </HBox>
        {this.state.edit ? (
          <Modal onClose={this.reset.bind(this)} title={this.lbl(`vehicle.property.${this.props.propertyName}`)}>
            <VBox center>
              {['0', '1', '2', '3'].map(value => (
                <Button
                  small
                  onClick={() => {
                    this.props.setTo(value);
                    this.reset();
                  }}
                >
                  {this.lbl(`task.progress.${value}`)}
                </Button>
              ))}
            </VBox>
          </Modal>
        ) : null}
      </Container>
    );
  }
}

SetActionStateButton0123Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setTo(value) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, ownProps.propertyName, value));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const SetActionStateButton0123 = compose(
  withConnect,
  withRouter,
)(SetActionStateButton0123Comp);
